export const SET_CLIENT = `client@SET_CLIENT`
